export var WalletTagType;
(function (WalletTagType) {
    WalletTagType["Connected"] = "connected";
    WalletTagType["Multichain"] = "multichain";
    WalletTagType["Installed"] = "installed";
    WalletTagType["QrCode"] = "qr-code";
    WalletTagType["GetStarted"] = "get-started";
})(WalletTagType || (WalletTagType = {}));
//# sourceMappingURL=walletTagType.js.map